export enum TimeZoneEnum {
  UTC = "UTC",
  AsiaJerusalem = "Asia/Jerusalem",
  EuropeLondon = "Europe/London",
  EuropeParis = "Europe/Paris",
  EuropeBerlin = "Europe/Berlin",
  EuropeRome = "Europe/Rome",
  EuropeMadrid = "Europe/Madrid",
}
